"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModerationStatusResponseModelSafetyStatus = void 0;
exports.ModerationStatusResponseModelSafetyStatus = {
    AppealApproved: "appeal_approved",
    AppealDenied: "appeal_denied",
    FalsePositive: "false_positive",
};
